import { NgClass } from '@angular/common';
import { HttpBackend, HttpClient } from '@angular/common/http';
import {
  Component,
  HostListener,
  inject,
  OnInit,
  output,
  signal,
} from '@angular/core';
import { Router } from '@angular/router';

import { IconComponent } from '@shared/lib/components';
import { EmbedMicroappDirective } from '@shared/lib/directives';
import {
  DerivedAuthService,
  GlobalSearchService,
  SingleSpaLoaderService,
} from '@shared/lib/services';

import { AvatarComponent } from '../avatar/avatar.component';
import { ProfileTrayComponent } from '../profile-tray/profile-tray.component';

@Component({
  selector: 'wu-header',
  imports: [
    EmbedMicroappDirective,
    IconComponent,
    ProfileTrayComponent,
    AvatarComponent,
    NgClass,
  ],
  templateUrl: './header.component.html',

  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  private readonly httpBackend = inject(HttpBackend);
  private readonly http = new HttpClient(this.httpBackend);
  private readonly router = inject(Router);
  readonly searchService = inject(GlobalSearchService);
  readonly isMicroappMode = inject(SingleSpaLoaderService).isFullScreen;
  readonly authService = inject(DerivedAuthService);

  readonly menuClick = output<void>();
  readonly userIconClick = output<void>();
  isBottomSheetOpen = signal<boolean>(false);
  readonly inboxCount = signal(0);
  // readonly notificationCount = signal(0);
  readonly isDesktop = signal(window.innerWidth >= 1024);

  isProfileMenuOpen = false;

  toggleProfileMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.isProfileMenuOpen = !this.isProfileMenuOpen;
  }

  @HostListener('document:click')
  closeProfileMenuOnOutsideClick(): void {
    if (this.isProfileMenuOpen) {
      this.isProfileMenuOpen = false;
    }
  }

  ngOnInit(): void {
    this.isDesktop.set(window.innerWidth >= 1024);
    this.http
      .get<{ value: any[] }>(
        'https://graph.microsoft.com/v1.0/me/mailFolders/inbox/messages',
        {
          params: {
            $top: 1000,
            $filter: 'isRead eq false',
            $orderby: 'receivedDateTime desc',
            $select: 'subject',
          },
          headers: {
            Authorization: `Bearer ${this.authService.accessToken()}`,
          },
        },
      )
      .subscribe({
        next: data => {
          this.inboxCount.set(data?.value?.length);
        },
      });
  }

  @HostListener('window:resize')
  onResize() {
    this.isDesktop.set(window.innerWidth >= 1024);
  }

  showBottomSheet() {
    this.isBottomSheetOpen.set(true);
    this.menuClick.emit();
  }

  @HostListener('window:search-click')
  handleSearchClick(): void {
    window.dispatchEvent(new CustomEvent('close-BottomSheet'));
    void this.router.navigate(['/search']);
  }
}
